import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ENV_CONFIG } from '@ps/core-config';

@Injectable({ providedIn: 'root' })
export class CompanyBuyerConfigNotificationApi {
  private readonly _httpClient = inject(HttpClient);
  private readonly _environmentConfig = inject(ENV_CONFIG);
  private readonly _baseUrl = this._environmentConfig.pureSpectrum.url;

  public registerWebhook(buyerId: number, webhook: string): Observable<void> {
    return this._httpClient
      .post<void>(`${this._baseUrl}/activities/v2/notifications`, {
        webhook,
        cmpId: buyerId,
      })
      .pipe(map(() => undefined));
  }

  public unsubscribe(buyerId: number): Observable<boolean> {
    return this._httpClient
      .put<void>(`${this._baseUrl}/activities/v2/notifications/unsubscribe`, {
        cmpId: buyerId,
      })
      .pipe(map(() => true));
  }
}
